import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-file-dropzone',
  imports: [TranslatePipe, MatIcon],
  templateUrl: './file-dropzone.component.html',
  styleUrl: './file-dropzone.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileDropzoneComponent {
  readonly accept = input('');
  readonly hint = input('');

  readonly fileSelected = output<File>();
  readonly cleared = output<void>();

  readonly file = signal<File | null>(null);
  readonly dragging = signal(false);

  // Drag-Events feuern auch beim Wechsel über Kind-Elemente; ein Zähler hält den
  // Hover-Zustand stabil, statt bei jedem dragleave zu flackern.
  private dragDepth = 0;

  onDragEnter(event: DragEvent): void {
    event.preventDefault();
    this.dragDepth++;
    this.dragging.set(true);
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.dragDepth = Math.max(0, this.dragDepth - 1);
    if (this.dragDepth === 0) this.dragging.set(false);
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.dragDepth = 0;
    this.dragging.set(false);
    this.take(event.dataTransfer?.files?.[0] ?? null);
  }

  onFileSelect(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.take(input.files?.[0] ?? null);
    input.value = '';
  }

  clear(): void {
    this.file.set(null);
    this.cleared.emit();
  }

  formatSize(bytes: number): string {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }

  private take(file: File | null): void {
    if (!file) return;
    this.file.set(file);
    this.fileSelected.emit(file);
  }
}
